import React from 'react';
import { Tooltip, TooltipTrigger } from 'react-aria-components';

/** Wraps a button that requires admin access: non-admins get it disabled with a tooltip hint. */
export function AdminButton({
  isAdmin,
  tooltipText,
  children,
}: {
  isAdmin: boolean;
  tooltipText: string;
  children: React.ReactElement<{ isDisabled?: boolean }>;
}) {
  if (isAdmin) {
    return children;
  }

  return (
    <TooltipTrigger delay={0}>
      {React.cloneElement(children, { isDisabled: true })}
      <Tooltip
        offset={8}
        placement="bottom"
        className="z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95"
      >
        {tooltipText}
      </Tooltip>
    </TooltipTrigger>
  );
}
